import { addMinutes, format } from "date-fns";

/**
 * Convert appointment date + startTime + duration
 * into Google Calendar format and ISO for Outlook
 */
export const formatCalendarDates = (
  date: string, // e.g. "09/25/2025"
  startTime: string, // e.g. "09:00"
  duration: number, // in minutes
) => {
  // Parse start time
  const [month, day, year] = date.split("/").map(Number);
  const [hours, minutes] = startTime.split(":").map(Number);

  const startDate = new Date(year, month - 1, day, hours, minutes);
  const endDate = addMinutes(startDate, duration);

  const formatForGoogle = (d: Date) => format(d, "yyyyMMdd'T'HHmmss");

  return {
    start: formatForGoogle(startDate),
    end: formatForGoogle(endDate),
  };
};

/**
 * Convert Google Calendar style date
 * into ISO format (YYYY-MM-DDTHH:mm:ssZ) for Outlook.
 */
export const googleToIso = (val: string): string => {
  if (!val.endsWith("Z")) {
    val = val + "Z";
  }
  if (!/^\d{8}T\d{6}Z$/.test(val)) {
    throw new Error(`Invalid Google date format: ${val}`);
  }

  const year = val.slice(0, 4);
  const month = val.slice(4, 6);
  const day = val.slice(6, 8);
  const hour = val.slice(9, 11);
  const minute = val.slice(11, 13);
  const second = val.slice(13, 15);

  return `${year}-${month}-${day}T${hour}:${minute}:${second}Z`;
};
